<template>
  <b-modal
    v-model="localIsActive"
    size="lg"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-title>
      Validar vista
    </template>

    <div v-if="loading" class="text-center">
      <b-spinner
        class="my-5"
        label="Loading"
        variant="primary"
      />
    </div>
    <div v-else-if="!loading && currentPreview">
      <div  class="row justify-content-center my-2">
        <div class="col-9">
          <preview-layout
            ref="refPreviewLayout"
            :close-icon="false"
            :selected-layout="currentPreview.id"
            :slot-height="35"
            @get-user-layouts-finish="setDataView"
        />
        </div>
      </div>
      <div v-if="userView.comments">
        <h5 class="mb-1">Comentario anterior</h5>
        <p class="mb-0">
          {{ userView.comments }}
        </p>
      </div>
      <b-form-group
        v-if="!isUserViewCommentedType"
        label="Agregar comentarios"
        label-for="comments"
        class="mt-1"
        rows="8"
        max-rows="8"
      >
        <b-form-textarea
          id="comments"
          v-model="comments"
          :class="isCommentsInvalid"
          placeholder="Ingresar texto"
          :plaintext="isUserViewCommentedType"
        ></b-form-textarea>
        <div v-if="errorComments" class="text-danger">
          {{ errorComments }}
        </div>
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button
          v-if="isUserViewCommentedType"
          variant="primary"
          :disabled="loadingAction"
          @click="openView()"
        >
          Abrir vista
        </b-button>
        <b-button
          v-if="!isUserViewCommentedType && currentPreview"
          variant="primary"
          :disabled="loadingAction"
          @click="addComments()"
        >
          Agregar comentarios
        </b-button>
        <b-button
          v-if="!isUserViewCommentedType && currentPreview"
          class="mx-1"
          variant="danger"
          :disabled="loadingAction"
          @click="rejectView()"
        >
          Rechazar
        </b-button>
        <b-button
          v-if="!isUserViewCommentedType && currentPreview"
          variant="success"
          :disabled="loadingAction"
          @click="userViewValidate()"
        >
          Validar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from '@axios';
import { computed,nextTick,ref } from '@vue/composition-api';
import PreviewLayout from '@/views/alarm_views/layout/PreviewLayout.vue';
import { SLOT_TYPES } from "@/config/layoutConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import store from '@/store';

export default {
  props: {
    userView: {
      type: Object
    },
    showModalUserViews:{
      type: Boolean
    }
  },
  components: {
    PreviewLayout
  },
  setup(props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const comments = ref(null);

    const currentPreview = ref(null);

    const errorComments = ref(null);

    const loading = ref(false);

    const loadingAction = ref();

    const refPreviewLayout = ref(null);

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showModalUserViews;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    const isCommentsInvalid = computed(() => errorComments.value ? 'is-invalid' : '');

    const isUserViewCommentedType = computed(() => props.userView.type === 'user_view_commented');

    //METHODS
    const addComments = () => {
      errorComments.value = null;

      if (!comments.value) {
        errorComments.value = 'El campo comentarios es requerido';
        return;
      }

      loadingAction.value = true;

      const id_user_view = props.userView.user_view.id;
      const payload = {
        comments: comments.value
      }

      axios.patch(`v1/user-views/${id_user_view}/add-comments`, payload)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          comments.value = null;

          emit('user-view-commented', props.userView.id);
          emit('user-views-with-comments');

          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }

    const findSlotWithoutData = (camera) => {
      const dataSlotLayout = getDataSlot(camera);
      //const nameSlotLayout = (camera) ? camera.camera.name : '';

      const slotData = {
        type: SLOT_TYPES.CAM_LIVE,
        name: '',
        data: dataSlotLayout
      }

      refPreviewLayout.value.findSlotWithoutData(slotData);
    }

    const getDataSlot = (camera) => {
      if (!camera) {
        return null;
      }

      const dataSlot = {
        ...camera,
        in_app_source	:	'subsystem_tree'
      }

      return dataSlot;
    }

    const getLayout = async (layoutId) => {
      loading.value = true;

      const { data }   = await axios.get(`v1/layout/${layoutId}`);

      if (data.data) {
        currentPreview.value = data.data;
      }

      loading.value = false;
    }

    const onHide = () => {
      emit('update:isActive', false);
    }

    const onShow = async () => {
      const { layout } = props.userView.data;

      await getLayout(layout);
    }

    const openView = () => {
      emit('open-view-modal');
      onHide();
    }

    const rejectView = async () => {
      errorComments.value = null;

      if (!comments.value) {
        errorComments.value = 'El campo comentarios es requerido';
        return;
      }

      loadingAction.value = true;

      const id_user_view = props.userView.user_view.id;
      const payload = {
        comments: comments.value
      }

      await axios.patch(`v1/user-views/${id_user_view}/reject`, payload)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          store.dispatch("grid/getUserViews", { max: 4, currentPage:1 });
          emit('user-view-rejected', props.userView.id);
          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }

    const setDataView = () => {
      const { slots } = props.userView.data;

      slots.forEach(slot => {
        const { data } = slot;

        nextTick(() => {
          findSlotWithoutData(data);
        });
      });

      emit('set-current-preview', currentPreview.value);
    }

    const userViewValidate = async () => {
      const id_user_view = props.userView.user_view.id;

      loadingAction.value = true;

      await axios.get(`v1/user-views/${id_user_view}/validate`)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          store.dispatch("grid/getUserViews", { max: 4, currentPage:1 });
          emit('user-view-validated', props.userView.id);
          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }

    return {
      comments,
      currentPreview,
      errorComments,
      loading,
      loadingAction,
      refPreviewLayout,

      localIsActive,
      isCommentsInvalid,
      isUserViewCommentedType,

      addComments,
      onHide,
      onShow,
      openView,
      rejectView,
      setDataView,
      userViewValidate
    }
  }
}
</script>

<style scoped>

</style>

